
import PainpointDetailContainer from 'containers/PainpointDetailContainer';

export default (props: any) => <PainpointDetailContainer {...props} />;
